export default "__VITE_ASSET__CP_EaIBG__"